if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        
        // Log when form submit listener is attached
        console.log('[Cart Add] ProductForm constructor - attaching submit listener');
        
        // Check if Globo is already intercepting
        const hasGloboOnForm = this.form.querySelector('input[name="properties[_has_gpo]"]') !== null;
        console.log('[Cart Add] ProductForm constructor - Globo detected on form:', hasGloboOnForm);
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        
        // Also listen with capture phase to catch before Globo
        this.form.addEventListener('submit', (e) => {
          console.log('[Cart Add] Submit event captured (capture phase)', {
            target: e.target,
            currentTarget: e.currentTarget,
            defaultPrevented: e.defaultPrevented,
            timeStamp: e.timeStamp
          });
        }, true);
        
        // Monitor for fetch calls to cart/add.js (Globo's endpoint)
        const originalFetch = window.fetch;
        window.fetch = function(...args) {
          const url = args[0];
          if (typeof url === 'string' && url.includes('/cart/add')) {
            console.log('[Cart Add] Fetch intercepted - cart add request:', {
              url: url,
              method: args[1]?.method || 'GET',
              hasBody: !!args[1]?.body,
              bodyType: args[1]?.body?.constructor?.name,
              isFormData: args[1]?.body instanceof FormData
            });
            
            if (args[1]?.body instanceof FormData) {
              const formData = args[1].body;
              console.log('[Cart Add] FormData in intercepted fetch:', {
                quantity: formData.get('quantity'),
                length: formData.get('properties[Length]'),
                hasGlobo: formData.get('properties[_has_gpo]'),
                allEntries: Array.from(formData.entries()).map(([key, value]) => ({key, value: String(value).substring(0, 50)}))
              });
            } else if (typeof args[1]?.body === 'string') {
              // Globo sends as string - parse it
              const bodyString = args[1].body;
              console.log('[Cart Add] String body in intercepted fetch (Globo method):', {
                bodyLength: bodyString.length,
                bodyPreview: bodyString.substring(0, 200),
                containsQuantity: bodyString.includes('quantity'),
                quantityMatch: bodyString.match(/quantity[=&]([^&]*)/i),
                lengthMatch: bodyString.match(/properties\[Length\][=&]([^&]*)/i),
                fullBody: bodyString // Show full body for analysis
              });
              
              // Try to parse as JSON (Globo uses JSON)
              try {
                const jsonBody = JSON.parse(bodyString);
                const itemsDetails = jsonBody.items?.map((item, index) => ({
                  index: index,
                  id: item.id,
                  variant_id: item.variant_id,
                  quantity: item.quantity,
                  properties: item.properties,
                  hasLengthProperty: !!item.properties?.Length,
                  lengthPropertyValue: item.properties?.Length,
                  allProperties: item.properties ? Object.keys(item.properties) : []
                }));
                
                console.log('[Cart Add] Parsed JSON body (Globo format):', {
                  isItemsArray: Array.isArray(jsonBody.items),
                  itemsCount: jsonBody.items?.length || 0,
                  items: itemsDetails,
                  fullJson: jsonBody
                });
                
                // Expand items for easier reading
                if (jsonBody.items && jsonBody.items.length > 0) {
                  console.log('[Cart Add] Items array expanded:', jsonBody.items);
                }
                
                // Check if this is a priced-by-length product and fix quantity in JSON
                const form = document.querySelector('product-form form');
                if (form) {
                  const ropeLengthFlag = form.querySelector('input[name="properties[_IsRopeByLength]"]');
                  const ropeLengthInput = form.querySelector('#rope-length-input');
                  const isPricedByLength = ropeLengthFlag?.value === 'true' || ropeLengthInput !== null;
                  
                  if (isPricedByLength) {
                    let metres = 0;
                    if (ropeLengthInput) {
                      metres = parseInt(ropeLengthInput.value, 10);
                    } else {
                      const lengthProp = form.querySelector('input[name="properties[Length]"]');
                      if (lengthProp?.value) {
                        const match = lengthProp.value.match(/(\d+)/);
                        if (match) metres = parseInt(match[1], 10);
                      }
                    }
                    
                    const expectedQuantity = Math.max(1, metres);
                    
                    console.log('[Cart Add] Priced-by-length check in Globo JSON:', {
                      isPricedByLength: isPricedByLength,
                      metres: metres,
                      expectedQuantity: expectedQuantity,
                      currentQuantities: jsonBody.items?.map(item => item.quantity),
                      needsFix: jsonBody.items?.some(item => item.quantity !== expectedQuantity)
                    });
                    
                    // Fix quantity in JSON items that have Length property
                    if (jsonBody.items && Array.isArray(jsonBody.items)) {
                      let fixed = false;
                      jsonBody.items.forEach((item, index) => {
                        // Check if this item has Length property or _IsRopeByLength flag
                        if (item.properties && (item.properties.Length || item.properties._IsRopeByLength === 'true')) {
                          if (item.quantity !== expectedQuantity) {
                            console.log('[Cart Add] Fixing quantity in JSON item', index, '- was:', item.quantity, 'should be:', expectedQuantity);
                            item.quantity = expectedQuantity;
                            fixed = true;
                          }
                        }
                      });
                      
                      if (fixed) {
                        // Convert back to string and update the fetch body
                        const fixedJsonString = JSON.stringify(jsonBody);
                        args[1].body = fixedJsonString;
                        console.log('[Cart Add] JSON body fixed - new body:', fixedJsonString.substring(0, 200));
                      }
                    }
                  }
                }
              } catch (e) {
                console.log('[Cart Add] Could not parse as JSON, trying URLSearchParams:', e);
                // Try to parse as URL-encoded
                try {
                  const params = new URLSearchParams(bodyString);
                  console.log('[Cart Add] Parsed URL-encoded body:', {
                    quantity: params.get('quantity'),
                    length: params.get('properties[Length]'),
                    hasGlobo: params.get('properties[_has_gpo]'),
                    allParams: Array.from(params.entries()).map(([key, value]) => ({key, value: String(value).substring(0, 50)}))
                  });
                } catch (e2) {
                  console.log('[Cart Add] Could not parse as URLSearchParams either:', e2);
                }
              }
            }
          }
          return originalFetch.apply(this, args);
        };
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        
        // Fix quantity input EARLY on button click (before Globo reads it)
        if (this.submitButton) {
          this.submitButton.addEventListener('click', (e) => {
            console.log('[Cart Add] Submit button clicked! (capture phase)', {
              button: this.submitButton,
              form: this.form,
              quantityInputBefore: this.form.querySelector('input[name="quantity"]')?.value,
              lengthProp: this.form.querySelector('input[name="properties[Length]"]')?.value
            });
            
            // Check if this is a priced-by-length product
            const ropeLengthFlag = this.form.querySelector('input[name="properties[_IsRopeByLength]"]');
            const ropeLengthInput = this.form.querySelector('#rope-length-input');
            const isPricedByLength = ropeLengthFlag?.value === 'true' || ropeLengthInput !== null;
            
            if (isPricedByLength) {
              // Get length from either input or property
              let metres = 0;
              if (ropeLengthInput) {
                metres = parseInt(ropeLengthInput.value, 10);
              } else {
                const lengthProp = this.form.querySelector('input[name="properties[Length]"]');
                if (lengthProp?.value) {
                  const match = lengthProp.value.match(/(\d+)/);
                  if (match) metres = parseInt(match[1], 10);
                }
              }
              
              if (metres > 0) {
                const expectedQuantity = Math.max(1, metres);
                
                // Find and fix quantity input BEFORE Globo reads it
                let quantityInput = this.form.querySelector('input[name="quantity"]') ||
                                   this.form.querySelector('.quantity__input') ||
                                   this.form.querySelector('[id^="Quantity-"]');
                
                if (quantityInput) {
                  const currentQuantity = parseInt(quantityInput.value) || 0;
                  if (currentQuantity !== expectedQuantity) {
                    console.log('[Cart Add] Fixing quantity input EARLY (before Globo reads it) - was:', currentQuantity, 'should be:', expectedQuantity);
                    quantityInput.value = expectedQuantity;
                    // Trigger input and change events to ensure any listeners see the update
                    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                    console.log('[Cart Add] Quantity input fixed early - new value:', quantityInput.value);
                  } else {
                    console.log('[Cart Add] Quantity input already correct:', currentQuantity);
                  }
                } else {
                  console.warn('[Cart Add] Could not find quantity input to fix early');
                }
              }
            }
            
            // Check if Globo has added any handlers
            setTimeout(() => {
              console.log('[Cart Add] After button click - checking if form was submitted:', {
                formSubmitted: false, // We'll check this
                globoElements: document.querySelectorAll('.gpo-option, [data-gpo-option]').length,
                hasGloboNow: this.form.querySelector('input[name="properties[_has_gpo]"]') !== null,
                quantityInputAfter: this.form.querySelector('input[name="quantity"]')?.value
              });
            }, 100);
          }, true); // Use capture phase - runs BEFORE other handlers
        }
        
        // Monitor for Globo form modifications
        if (this.form) {
          const formObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                  if (node.nodeType === 1) { // Element node
                    if (node.matches && (node.matches('.gpo-option, [data-gpo-option], input[name*="gpo"], input[name*="Globo"]') || 
                        node.querySelector && node.querySelector('.gpo-option, [data-gpo-option]'))) {
                      console.log('[Cart Add] Globo element detected in form:', {
                        element: node,
                        tagName: node.tagName,
                        className: node.className,
                        name: node.name,
                        id: node.id
                      });
                    }
                  }
                });
              }
            });
          });
          
          formObserver.observe(this.form, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['name', 'id', 'class']
          });
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        console.log('[Cart Add] onSubmitHandler called!', {
          eventType: evt.type,
          target: evt.target,
          currentTarget: evt.currentTarget,
          submitButtonDisabled: this.submitButton.getAttribute('aria-disabled'),
          form: this.form,
          formAction: this.form.action,
          formMethod: this.form.method
        });
        
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('[Cart Add] Submit blocked - button disabled');
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Log form data before submission for priced-by-length products
        const ropeLengthFlag = this.form.querySelector('input[name="properties[_IsRopeByLength]"]');
        const ropeLengthInput = this.form.querySelector('#rope-length-input');
        const isPricedByLength = ropeLengthFlag?.value === 'true' || ropeLengthInput !== null;
        
        console.log('[Cart Add] onSubmitHandler - Checking priced-by-length:', {
          ropeLengthFlagExists: !!ropeLengthFlag,
          ropeLengthFlagValue: ropeLengthFlag?.value,
          ropeLengthInputExists: !!ropeLengthInput,
          ropeLengthInputValue: ropeLengthInput?.value,
          isPricedByLength: isPricedByLength
        });
        
        if (isPricedByLength) {
          // Get length from either the input or the property
          let metres = 0;
          if (ropeLengthInput) {
            metres = parseInt(ropeLengthInput.value, 10);
          } else {
            // Try to get length from the Length property (format: "10m")
            const lengthProp = this.form.querySelector('input[name="properties[Length]"]');
            if (lengthProp?.value) {
              const lengthMatch = lengthProp.value.match(/(\d+)/);
              if (lengthMatch) {
                metres = parseInt(lengthMatch[1], 10);
              }
            }
          }
          
          const expectedQuantity = Math.max(1, metres);
          
          // Find quantity input - try multiple selectors including searching in shadow DOM
          let quantityInput = this.form.querySelector('input[name="quantity"]') || 
                             this.form.querySelector('.quantity__input') ||
                             this.form.querySelector('[id^="Quantity-"]') ||
                             document.querySelector('input[name="quantity"]') ||
                             document.querySelector('[id^="Quantity-"]');
          
          // Also try to find it by searching all inputs in the form
          if (!quantityInput) {
            const allInputs = Array.from(this.form.querySelectorAll('input'));
            quantityInput = allInputs.find(i => i.name === 'quantity' || i.id?.includes('Quantity'));
          }
          
          console.log('[Cart Add] Priced-by-length product - Form data before submission:', {
            metres: metres,
            expectedQuantity: expectedQuantity,
            quantityInputFound: !!quantityInput,
            quantityInputValue: quantityInput?.value,
            quantityInputName: quantityInput?.name,
            quantityInputId: quantityInput?.id,
            length: this.form.querySelector('input[name="properties[Length]"]')?.value,
            uniqueId: this.form.querySelector('input[name="properties[UniqueId]"]')?.value,
            variantId: this.form.querySelector('[name="id"]')?.value,
            allQuantityInputs: Array.from(this.form.querySelectorAll('input')).filter(i => i.name.includes('quantity') || i.id?.includes('Quantity')).map(i => ({name: i.name, id: i.id, value: i.value, type: i.type}))
          });
          
          // Ensure quantity is set correctly in the actual input element
          if (quantityInput && metres > 0) {
            if (parseInt(quantityInput.value) !== expectedQuantity) {
              console.log('[Cart Add] Fixing quantity input element - was:', quantityInput.value, 'should be:', expectedQuantity);
              quantityInput.value = expectedQuantity;
              // Trigger change event to ensure any listeners are notified
              quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (metres > 0) {
            console.warn('[Cart Add] Quantity input not found! Will fix in FormData instead.');
          }
        }

        const formData = new FormData(this.form);
        
        // Log Globo detection and form state
        const hasGlobo = this.form.querySelector('input[name="properties[_has_gpo]"]') !== null;
        const globoInputs = Array.from(this.form.querySelectorAll('input')).filter(i => 
          i.name.includes('gpo') || i.name.includes('Globo') || i.id?.includes('gpo')
        );
        
        console.log('[Cart Add] Globo detection:', {
          hasGlobo: hasGlobo,
          globoInputs: globoInputs.map(i => ({name: i.name, id: i.id, value: i.value})),
          allFormInputs: Array.from(this.form.querySelectorAll('input')).map(i => ({
            name: i.name,
            id: i.id,
            value: i.value,
            type: i.type
          }))
        });
        
        // Log what's actually being sent and fix if needed
        if (isPricedByLength) {
          // Get length from either the input or the property
          let metres = 0;
          if (ropeLengthInput) {
            metres = parseInt(ropeLengthInput.value, 10);
          } else {
            // Try to get length from the Length property (format: "10m")
            const lengthProp = this.form.querySelector('input[name="properties[Length]"]');
            if (lengthProp?.value) {
              const lengthMatch = lengthProp.value.match(/(\d+)/);
              if (lengthMatch) {
                metres = parseInt(lengthMatch[1], 10);
              }
            }
          }
          
          if (metres > 0) {
            const expectedQuantity = Math.max(1, metres).toString();
            const actualQuantity = formData.get('quantity');
            
            console.log('[Cart Add] FormData being sent:', {
              quantity: actualQuantity,
              expectedQuantity: expectedQuantity,
              metres: metres,
              length: formData.get('properties[Length]'),
              uniqueId: formData.get('properties[UniqueId]'),
              variantId: formData.get('id'),
              hasGlobo: hasGlobo,
              globoProperties: Array.from(formData.entries()).filter(([key]) => key.includes('gpo') || key.includes('Globo')),
              allFormData: Array.from(formData.entries()).filter(([key]) => key.includes('quantity') || key.includes('Length') || key.includes('UniqueId') || key.includes('gpo'))
            });
            
            // Double-check and fix quantity in FormData if needed
            if (actualQuantity !== expectedQuantity) {
              console.log('[Cart Add] FormData quantity mismatch - fixing. Was:', actualQuantity, 'Should be:', expectedQuantity);
              formData.set('quantity', expectedQuantity);
              console.log('[Cart Add] FormData quantity after fix:', formData.get('quantity'));
            }
          }
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        // Log the actual request body for priced-by-length products
        if (isPricedByLength) {
          // Convert FormData to object for logging
          const formDataObj = {};
          for (const [key, value] of formData.entries()) {
            formDataObj[key] = value;
          }
          console.log('[Cart Add] Actual request body (FormData as object):', formDataObj);
          console.log('[Cart Add] Quantity in FormData before fetch:', formData.get('quantity'));
          console.log('[Cart Add] All quantity-related entries:', Array.from(formData.entries()).filter(([key]) => key.toLowerCase().includes('quantity')));
        }
        
        // Log right before fetch to catch any last-minute changes
        console.log('[Cart Add] Right before fetch - Final FormData check:', {
          quantity: formData.get('quantity'),
          hasGlobo: hasGlobo,
          formDataEntries: Array.from(formData.entries()).length,
          quantityInputsInForm: Array.from(this.form.querySelectorAll('input[name="quantity"], input[id*="Quantity"]')).map(i => ({
            name: i.name,
            id: i.id,
            value: i.value
          }))
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Log cart response for priced-by-length products
            // Re-check in case variables are out of scope
            const ropeLengthFlagCheck = this.form.querySelector('input[name="properties[_IsRopeByLength]"]');
            const ropeLengthInputCheck = this.form.querySelector('#rope-length-input');
            const isPricedByLengthCheck = ropeLengthFlagCheck?.value === 'true' || ropeLengthInputCheck !== null;
            
            if (isPricedByLengthCheck || isPricedByLength) {
              console.log('[Cart Add] Cart response (full):', response);
              console.log('[Cart Add] Cart response (parsed):', {
                status: response.status,
                item_count: response.item_count,
                items: response.items,
                itemsArray: Array.isArray(response.items) ? response.items : Object.values(response.items || {}),
                firstItem: response.items?.[0] || (response.items && Object.values(response.items)[0]),
                isPricedByLength: isPricedByLength,
                isPricedByLengthCheck: isPricedByLengthCheck
              });
              
              // Check the actual cart item that was added
              if (response.items) {
                const itemsArray = Array.isArray(response.items) ? response.items : Object.values(response.items);
                const addedItem = itemsArray.find(item => item.variant_id?.toString() === formData.get('id'));
                if (addedItem) {
                  console.log('[Cart Add] Added item details:', {
                    variant_id: addedItem.variant_id,
                    quantity: addedItem.quantity,
                    properties: addedItem.properties,
                    line_price: addedItem.line_price,
                    final_line_price: addedItem.final_line_price
                  });
                }
              }
            }
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
